import React from 'react';
import { ShieldCheck, Lock, Sparkles, Send } from 'lucide-react';
import { GUARANTEE_ITEMS } from '../mock';

const ICONS = { ShieldCheck, Lock, Sparkles, Send };

const GuaranteeStrip = () => (
  <section className="gstrip" data-testid="guarantee-strip">
    <div className="container gstrip-grid">
      {GUARANTEE_ITEMS.map((g) => {
        const Ic = ICONS[g.icon];
        return (
          <div className="gitem" key={g.title}>
            <div className="gi-icon"><Ic size={22} /></div>
            <div>
              <b>{g.title}</b>
              <span>{g.desc}</span>
            </div>
          </div>
        );
      })}
    </div>
  </section>
);

export default GuaranteeStrip;
